import protoRoot from "../proto-root";
import createMessage from "./createMessage";
import ActivityLogVideoPreview from "../private/ActivityLogVideoPreview";

const name = "videoRecordingDidFinishMessage";

function create({ result, event, thumbnailData }) {
  const VideoRecordingDidFinishMessage = protoRoot.lookupType(
    `comm.VideoRecordingDidFinishMessage`
  );
  const Result = VideoRecordingDidFinishMessage.lookupEnum("Result");

  return createMessage({
    [name]: VideoRecordingDidFinishMessage.create({
      result: Result.values[result],
      video: ActivityLogVideoPreview.create({ event, thumbnailData })
    })
  });
}

export default {
  create,
  name
};

// message VideoRecordingDidFinishMessage {
//   enum Result {
//       SUCCESS = 0;
//       INTERRUPTION = 1;
//       FAILURE = 2;
//   }
//   Result result = 1;
//   ActivityLogVideoPreview video = 2;
// }
